export default function ConditionalWrapper({ wrapper: Wrapper, if: condition, children }) {
  return condition ? <Wrapper>{children}</Wrapper> : children
}
